import { SEARCH_BICYCLE } from '../request-objects/search-requests';
import { formAxiosObject } from '../../common/helpers';

export const searchBicycleApi = (serial) => {
  return formAxiosObject(SEARCH_BICYCLE, null, null, { serial });
};
